module.exports = __webpack_public_path__ + "static/media/mdf.8d5dace5.svg";